import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UseCase } from '../../base';
import { PrivateLocationsForPP } from '../../domain/models';
import { GetStopsForPlanRequest } from '../../domain/requests';
import { LocationsRepository } from '../../repositories';

@Injectable({providedIn: 'root'})
export class GetStopsForPlanUsecase
  implements UseCase<GetStopsForPlanRequest, PrivateLocationsForPP[]>
{
  constructor(private locationRepository: LocationsRepository) {}

  execute(params: GetStopsForPlanRequest): Observable<PrivateLocationsForPP[]> {
    return this.locationRepository.getStopsForPlan(params);
  }
}
